
ACDiscountApp.CartPage.Show_CalculateTier = function () {
  let TierProducts = [];
  var postDataDiscountArrayObject = [];
  var discountMsg = "TIERED_DISCOUNT";

  // Utility function to create a discount object, used in all three discount types.
  function createDiscountObject(msg, variantId, value) {
    return {
      message: msg,
      targets: [{ productVariant: { id: variantId } }],
      value: value,
    };
  }

  // Creates a percentage discount object as per Shopify requirements.
  function createPercentageDiscountObject(msg, percentage, variantId) {
    return createDiscountObject(msg, variantId, {
      percentage: { value: percentage },
    });
  }

  // Creates a fixed amount discount object and calculates the total discount amount.
  function createAmountOffDiscountObject(
    msg,
    variantId,
    currencyRate,
    amount,
    qtys
  ) {
    const totalDiscountedAmount = (amount * currencyRate * qtys).toFixed(2);
    return createDiscountObject(msg, variantId, {
      fixedAmount: { amount: totalDiscountedAmount },
    });
  }

  // Creates a discounted price object and calculates the discount based on the original price.
  function createDiscountedPriceDiscountObject(
    msg,
    variantId,
    currencyRate,
    amount,
    qtys,
    price
  ) {
    let discountAmount = (amount * currencyRate).toFixed(2);
    price = Number(price);
    discountAmount = Number(discountAmount);
    if (price > discountAmount) {
      const discountValue = (price - discountAmount).toFixed(2);
      const totalDiscountedAmount = (discountValue * qtys).toFixed(2);

      return createDiscountObject(msg, variantId, {
        fixedAmount: { amount: totalDiscountedAmount },
      });
    }

    // Return null or a default value if no discount applies (optional based on your use case)
    return null;
  }

  async function setDateTimeInCart() {
    
    try {
      let cartAttributes = globalFieldsCartPage_AC.cartObj.items.length < 12 
  ? `${globalFields.Storetime()},${Shopify.shop}`  
  : JSON.stringify(postDataDiscountArrayObject);

      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            Discountly_dateTime: cartAttributes,
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      await fetch("/cart.js").then((r) =>
        r.json().then((data) => ({ status: r.status, body: data }))
      );
    } catch (error) {
      // console.error('Failed to update cart:', error);
    }
  }


    // Item and line Item Price Selector;
   var cartPageItemPrice = '.cart-item__info.cart-item-price .m-0.original-price,.ac-cart-original-item-price';
   var cartPageLineItemPrice = '.cart-items .cart-item__total.price,.ac-cart-total-price';

   var drawerItemPrice = '.drawer__cart-items-wrapper  .cart-item__details ,.ac-drawerItemPrice';
   var drawerLineItemPrice = '.drawer__cart-items-wrapper .cart-item .cart-item__totals.right';
  
    // Cart Total Selector Drawer and cart page;
   var cartPageCartTotalPrice = '.cart .original-subtotal .suntotal-price';

   var drawerCartTotalPrice = '.cart-drawer__footer .totals .totals__subtotal-value';

   // Saving Message 
   var savingMessageCartPage = '#cart-summary .original-subtotal';
    // CheckOut Button;
   var checkoutButtonCartPage = '.cart.form button[name="checkout"],.ac-cart-checkout';
   
   var checkoutButtonDrawerPage = '.cart-drawer__checkout-buttons button[name="checkout"],.ac-DrawerPage-checkout';


   var UpdateCartItem = function (item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index,discountMsgTitle) {
   // return
      if (isUpdate) {
         let findSelecter = ''
        if(jQuery(cartPageItemPrice).eq(index).find('.cart-item__discounted-prices').length == 1){findSelecter = '.cart-item__discounted-prices'}
        else{findSelecter = '.product-option:first'}
        //updatedItemPrice = roundToTwo(updatedItemPrice);
      var originalItemPrice = globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), originalLinePrice = globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
      var condition1 = updatedItemPrice == originalItemPrice;
      updatedItemPrice = globalFields.ConvertToFixedDecimalString(updatedItemPrice), updatedLinePrice = globalFields.ConvertToFixedDecimalString(updatedLinePrice);
        //$('.discounts.list-unstyled').hide()
       let caculatedPrice = (originalItemPrice  -  updatedItemPrice) * item.quantity;
          caculatedPrice = !isNotInRange || !condition1 ? globalFields.ConvertToFixedDecimalString(caculatedPrice):0;
          let discountCoupon = caculatedPrice
    
  caculatedPrice =  discountMsgTitle != undefined && caculatedPrice>0?`<div class="discount text-sm inline-flex items-center" dir="auto" style="color: var(--colorTextSavings);"> <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon"><g fill="none" fill-rule="evenodd"><g transform="translate(8.855 3)"><path d="m6.677.544 5.01 4.24a1 1 0 0 1 .354.764V17a1 1 0 0 1-1 1H1.02a1 1 0 0 1-1-1V5.497a1 1 0 0 1 .358-.767L5.389.54a1 1 0 0 1 1.288.004z" stroke="currentColor" stroke-width="1.5"></path><path stroke="currentColor" stroke-width="1.5" stroke-linecap="square" d="M.5 14.024h11"></path><circle fill="currentColor" cx="6" cy="5.052" r="1"></circle></g><path d="M9.988 21H4.125a1 1 0 0 1-1-1V8.497a1 1 0 0 1 .359-.767l5.01-4.19a1 1 0 0 1 1.288.004l2.167 1.834" stroke="currentColor" stroke-width="1.5"></path><path stroke="currentColor" stroke-width="1.5" stroke-linecap="square" d="M3.605 17.024h5.25"></path></g></svg>${discountMsgTitle} </div>`:`<small class="cart__discount discounted_price"></small>`
  
jQuery('.ac-cart-original-item-price,.ac-drawerItemPrice').eq(index).after(caculatedPrice);//drawer LineItem Price  html
        //.mt-3.mb-2.font-bold .mt-2
        if (isNotInRange || condition1) {
      jQuery(cartPageItemPrice).eq(index).html('<div><span style="margin-right: 7px;" class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
      jQuery(drawerItemPrice).eq(index).html('<div ><span class="money"style="margin-right: 7px;" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
      jQuery(cartPageLineItemPrice).eq(index).html('<div ><span class="money" style="margin-right: 5px;" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
      jQuery(drawerLineItemPrice).eq(index).html('<div style="font-weight: bold;"><span><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></span><div>');
      }
      else {
      originalItemPrice = globalFields.ConvertToFixedDecimalString(originalItemPrice), originalLinePrice = globalFields.ConvertToFixedDecimalString(originalLinePrice);
       jQuery(cartPageItemPrice).eq(index).html('<div class="cart-item__original-price" style=" flex-wrap: wrap; display: flex; height: fit-content; font-weight:bold; width:100px; "><span class="money" style="margin-right: 7px;" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></div>');
      jQuery(drawerItemPrice).eq(index).html('<span  style=" flex-wrap: wrap; display: flex; height: fit-content; font-weight:bold; width:100px;"><span class="money" style="margin-right: 7px;" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></span><span style=" font-weight: bold; " class="cart-item__original-price" style=" flex-wrap: wrap; display: flex; height: fit-content; width: 100px; font-weight:bold; "><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></span>');
      jQuery(cartPageLineItemPrice).eq(index).html('<div ><span style="color: var(--color-primary);"><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></span><div class="cart-item__original-price" ><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalLinePrice, globalFields.amount) + '</span></s></div></div>');
      jQuery(drawerLineItemPrice).eq(index).html('<span  style=" flex-wrap: wrap; display: flex; height: fit-content;font-weight:bold; width:100px; <span><span class="money" style="margin-right: 7px;" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></span><span class="cart-item__original-price" style=" flex-wrap: wrap; display: flex; height: fit-content;width: 100px;font-weight:bold; "><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalLinePrice, globalFields.amount) + '</span></s></span></span>');
      }
      }
}

  var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
    if(globalFieldsCartPage_AC.cartObj.items.length < 12)return 
    if (isUpdate) {
        updatedTotalPrice = globalFields.ConvertToFixedDecimalString(updatedTotalPrice), originalTotalPrice = globalFields.ConvertToFixedDecimalString(originalTotalPrice);
        if (originalTotalPrice != updatedTotalPrice) {
        jQuery(drawerCartTotalPrice).html(' <span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
        jQuery(cartPageCartTotalPrice).html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
       }
        else {
       jQuery(drawerCartTotalPrice).html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
        jQuery(cartPageCartTotalPrice).html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
      }
    }
}

   var UpdateSavingMessage = function (isUpdate) {
        if (priceDiff > 0 && isUpdate && globalFields.isCartPage) {
            var saveMessage = globalFields.settings.cart_saving_message.replace('{{discount_amount}}', '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + priceDiff.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(priceDiff.toFixed(2), globalFields.amount) + '</span>');
            var saveHtml = '<span id="saved-banner">' + saveMessage + '</span>';
          if (jQuery(window).width() < 700) {
            jQuery('#saved-banner-div').length == 0 ? jQuery('.cart__footer2 .totals').after('<div id="saved-banner-div" style="text-align: center;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
          else{
            jQuery('#saved-banner-div').length == 0 ? jQuery('.cart__foot2er .totals').after('<div id="saved-banner-div" style="text-align: end;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
        }
        else if (globalFields.isCartPage) {
            jQuery('#saved-banner-div').remove();
        }
    }

  function roundToTwo(num) {
  return Number((Math.round(num * 100) / 100).toFixed(2));
}

var CheckoutClickCart = function () {
    async  function CallGetCodecart() { // This is only for the cart page
    var checkValue = checkMinLength(globalFieldsCartPage_AC.cartObj.items.length);
       if(!checkValue){
         return false;
       }
        TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
       await setDateTimeInCart();
        window.location.href = '/checkout';
    }
    jQuery(checkoutButtonCartPage).once('click', CallGetCodecart);
};


   var CheckoutClickAjax = function () {
 async function CallGetCodeAjax() {// this is  only for ajax and drawer 
     var checkValue = checkMinLength(globalFieldsCartPage_AC.cartObj.items.length);
       if(!checkValue){
         return false;
       }
     TieredPricingCart(globalFieldsCartPage_AC.cartObj, false);
      await setDateTimeInCart();
     window.location.href = '/checkout'
 }
 jQuery(checkoutButtonDrawerPage).once('click', CallGetCodeAjax);
}

  jQuery.fn.once = function(a, b) {
   return this.each(function() {
    jQuery(this).off(a).on(a,b);
   });
 };
  

    var ReInvokeAjaxCartButton = function () {
        jQuery('.mb_cart.mb_item button.btn, .top-header .dropdown-cart button.btn').off("click"); CheckoutClickAjax();
    }
    var variantIdsToSend = [], minimumDiscountSubtotal = 0, priceDiff = 0;
  	var hide_buttons = null;
  	var HideAdditionalPayments = function() {      
      hide_buttons = setInterval(function() {
        if(jQuery('.additional_checkout_buttons, .dynamic-checkout__content').length>0){
          jQuery('.additional_checkout_buttons, .dynamic-checkout__content').hide();
          clearInterval(hide_buttons);
        }
      }, 500);
    }


    var variantIdsToSend = [],
    minimumDiscountSubtotal = 0,
    priceDiff = 0;
    var TieredPricingCart = function (cartObject, isUpdate) {
     
         variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updatedTotalPrice = 0;
      TierProducts = [];postDataDiscountArrayObject = [];
        for (k = 0; k < cartObject.items.length; k++) {
            var item = cartObject.items[k], isInRange = true; itemTiers = GetTiersFromTiersArray(item.variant_id);
                 $(`.cart__items .cart-item__error .cart-item__error-text`).eq(k).text('');
             $(`.cart__items .cart-item__error`).eq(k).attr('hidden', true);
          if (itemTiers != undefined && itemTiers.status  &&  globalFields.StartEndDateValid(itemTiers.start_date, itemTiers.end_date)) {
            let DiscountAppliedOn = itemTiers.DiscountAppliedON != null &&  itemTiers.DiscountAppliedON  != '' &&  itemTiers.DiscountAppliedON != undefined ? true : false;
            let Location_Tag_s = itemTiers.Location_Tag_ != null &&  itemTiers.Location_Tag_  != '' &&  itemTiers.Location_Tag_ != undefined ? true : false;
               if(DiscountAppliedOn){
                if(Location_Tag_s){
                   let DiscountAppliedOnTag =itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ? true : false;
                   let LocationObject = Object.keys(itemTiers.Location_Tag_);
                   if(LocationObject[0] == 'StoreLocation'){
                    let StoreLocationcheck =  itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
                    if(StoreLocationcheck && DiscountAppliedOnTag){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                      }else{
                      updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                      }
                   }else{
                   let TierLocation = itemTiers.Location_Tag_[LocationObject[0]];
                   let CusotmerCountryLocation = globalFields.Customercountry;
                   let CusotmerCityLocation = globalFields.Customercity;
                   let CustomerLocationcheck_1 = (arr, arr1) =>{return arr.some(item => arr1.includes(item))};
                   let CustomerLocationcheck_2 = (arr2, arr3) =>{return arr2.some(item => arr3.includes(item))};
                   let CityValue = CustomerLocationcheck_1(TierLocation,CusotmerCountryLocation);
                   let CountryValue = CustomerLocationcheck_2(TierLocation,CusotmerCityLocation);
                     if(DiscountAppliedOnTag && (CityValue || CountryValue)){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                     }else{
                       updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                     }
                   }
                                                   
                 }else{
                  if(itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ){
                   var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                  updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                  if (rslt[1]) {
                  updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                  }
                 }else{
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                 }
                 }
                 
               }else{
                var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                if (rslt[1]) {
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                }
                 
               }

            
             }
            else {
              
                UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), true, true, k,'');
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            }
          
            if (!isInRange) {
                minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100); variantIdsToSend.push(item.variant_id);
            }
        }
        UpdateCartSubtotal(isUpdate, globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice), globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100));
        priceDiff = globalFields.ConvertToFixedDecimalNumber((globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100) - globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice)));
        UpdateSavingMessage(isUpdate);
      setDateTimeInCart()
            makeEnableDisablebtn(false)
      	if(priceDiff){
          HideAdditionalPayments();
        }
      	setTimeout(function(){
          clearInterval(hide_buttons);
        }, 5000);
    }
    setTimeout(function(){
    clearInterval(hide_buttons);
    }, 10000);
    
    var GetTiersFromTiersArray = function (variantId) {
        var tierObj = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.variant_id === variantId); });
        if (tierObj[0].tiers == "[]") {
            return undefined;
        }
        else {
            return globalFields.GetTierObject(tierObj[0].tiers[0], variantId);
        }
    }

    var CalculateTier = function (item, itemTiers, updatedTotalPrice, isUpdate, isNotInRange, index) {
      let isFound = TierProducts.some(element => {if (element.VarientID === item.variant_id) { return true;}return false;});
        CalculateMinQuantityCart(itemTiers.tier_min[0],item,index)
      for (i = 0; i < itemTiers.tier_min.length; i++) {
            var allVariantItemQty = 0;
            var tierPrice = parseFloat(itemTiers.tier_values[i]);
            let tempTierProductsobj = {};
           let postDataDiscountObject = {};
            var minTier = parseInt(itemTiers.tier_min[i]), maxTier = itemTiers.tier_max[i] != 'max' ? parseInt(itemTiers.tier_max[i]) : itemTiers.tier_max[i];
            var updatedItemPrice = 0, updatedLinePrice = 0, condition1 = false, condition2 = false;

              
        if(itemTiers.mixMatch){
          if (itemTiers.entity_type === 'products' || itemTiers.entity_type === 'collections') {
                var tempItemArray = [];
                if (itemTiers.entity_type === 'collections') {
                    var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'collections' && n.tiers[0].mixmacthentityId == itemTiers.mixmacthentityId && n.tiers[0].mixMatch); });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                }
                if (itemTiers.entity_type === 'products') {
                    var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'products' && n.tiers[0].mixmacthentityId == itemTiers.mixmacthentityId && n.tiers[0].mixMatch); });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                }

                for (j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
            }
            else {
                   var tempItemArray = [];
                    var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'variants' && n.tiers[0].mixmacthentityId == itemTiers.mixmacthentityId && n.tiers[0].mixMatch); });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                for (j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;

               }
                
              }
              else{
                if (itemTiers.entity_type === 'products' || itemTiers.entity_type === 'collections') {
                var tempItemArray = [];
                if (itemTiers.entity_type === 'collections') {
                    var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'collections' && n.tiers[0].entity_id == itemTiers.entity_id); });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                }
                else {
                    tempItemArray = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.product_id == item.product_id ); });
                }

                for (j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
            }
            else {
                condition1 = item.quantity >= minTier;
                condition2 = maxTier == "max" || item.quantity <= maxTier;
            }
              }
discountMsg = itemTiers.discountCouponTitle || discountMsg;


            if (condition1 && condition2) {
              var Vid = `gid://shopify/ProductVariant/${item.variant_id}`;
              var currencyRate = Shopify.currency.rate;
              var qtys = item.quantity;
              var price = Number(item.original_price / 100).toFixed(2);
              
                isNotInRange = false;
                if (itemTiers.discount_type == 'percentage') {
                  let originalPriceCut = ((item.original_price / 100)/100)*(parseFloat(tierPrice))
                   // var originalPriceCut = parseFloat(globalFields.ConvertToFixedDecimalNumber((parseFloat(tierPrice) / 100) * globalFields.ConvertToFixedDecimalNumber(item.original_price / 100)));
                   // updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - originalPriceCut);
                    updatedItemPrice = (item.original_price / 100) - originalPriceCut;
                    updatedItemPrice = roundToTwo(updatedItemPrice);
                  if(!isFound){
                      tempTierProductsobj['Discountvalue'] = tierPrice;
                      tempTierProductsobj['DiscountType'] = itemTiers.discount_type;
                      tempTierProductsobj['VarientID'] = item.variant_id;
                      let resposne = createPercentageDiscountObject(discountMsg,tierPrice,Vid);
                      postDataDiscountObject = resposne;
                    }  
                }
                else if (itemTiers.discount_type == 'fixed') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(globalFields.ConvertToFixedDecimalNumber(item.original_price / 100) - parseFloat(tierPrice* currencyRate));
                   if(!isFound){
                      let resposne = createAmountOffDiscountObject(discountMsg,Vid,currencyRate,tierPrice, qtys);
            postDataDiscountObject = resposne;
            tempTierProductsobj["Discountvalue"] = postDataDiscountObject.value.fixedAmount.amount;
            tempTierProductsobj["DiscountType"] = itemTiers.discount_type;
            tempTierProductsobj["VarientID"] = `gid://shopify/ProductVariant/${item.variant_id}`;
                    }
                 }
                else if (itemTiers.discount_type == 'fixed_price') {
                    updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(parseFloat(tierPrice* currencyRate));
                    if(!isFound){
            tempTierProductsobj["Discountvalue"] = tierPrice;
            tempTierProductsobj["DiscountType"] = itemTiers.discount_type;
            tempTierProductsobj["VarientID"] = `gid://shopify/ProductVariant/${item.variant_id}`;
            let resposne = createDiscountedPriceDiscountObject(discountMsg, Vid,currencyRate,tierPrice,qtys,price);
            postDataDiscountObject = resposne;
                    } 
                }

                if (updatedItemPrice < 0) { updatedItemPrice = 0; }
                if(updatedItemPrice <= item.original_price/100){
                    updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
                    UpdateCartItem(item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index,discountMsg);
             }else{isNotInRange = true}
        if (!isFound) {
          if (postDataDiscountObject != null) {
            postDataDiscountArrayObject.push(postDataDiscountObject);
          TierProducts.push(tempTierProductsobj);
          }
        }
            }
        }
        if (isNotInRange) {
          UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index,'');
        }
        return [updatedTotalPrice, isNotInRange];
    }

    var DiscountCodeCookie = function (discount_code) {
        jQuery.ajax({
            type: "HEAD", url: "/discount/" + discount_code,
            success: function (_result) { },
            error: function (e) { console.log(e.statusText); }
        })
    }

    var FetchCartTiers = function () {
        jQuery.ajax({
            async: false,
            url: "/cart/?view=ac_cart_tiers",
            success: function (result) {
                globalFieldsCartPage_AC.cartTiersArray = JSON.parse(result);
                TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
                CheckoutClickAjax();

            },
            error: function (e) { console.log(e.statusText); }
        });
    }
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
        ProcessCartResponse(settings.url, xhr.responseText);
    });

    var ProcessCartResponse = function (splittedUrl, responseText) {
        if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
            splittedUrl = splittedUrl.split("?");
    
          if(splittedUrl[0] == "/cart/add" ){
            setTimeout(function () {
              displayTiers.DisplayTiersFn(); displayTiers.OnVariantChange();
            }, 5000);
          }
            if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js") {
              $('.discounts.list-unstyled').hide();
              jQuery('.quantity__button').on('click', function (event) {
                event.preventDefault(); // Prevent default behavior (if any)
              });
                globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
                setTimeout(function () {
                    FetchCartTiers();
                }, 1000);
            }
        }
    }


 try {
    var nativeFetch = window.fetch;
    window.fetch = function (...args) {
        try {
            if (typeof args[0] === 'string' && (args[0].includes("/cart/change") || args[0].includes("/cart/add"))) {
                  makeEnableDisablebtn(true);
               setTimeout(function () {
                  makeEnableDisablebtn(true);
                    fetch('/cart.js')
                        .then(r => r.json().then(data => ({ status: r.status, body: data })))
                        .then(obj => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)));
                }, 1200);
            }
        } catch (err) {
            console.error("Error in intercepting fetch:", err);
        }
        return nativeFetch.apply(window, args);
    }
} catch (e) {
    console.error("Error in overriding fetch:", e);
}
  $(document).ready(function () {
    $(document).on("keyup", ".minicart input.quantity-input,.page-cart input.quantity-input", function () {

   //   makeEnableDisablebtn(true)
      setTimeout(() => {
        $(this).blur(); // Triggers the blur event
      }, 800);
    });

    $(document).on("blur", ".minicart input.quantity-input,.page-cart input.quantity-input", function () {
     // console.log('blur')
      setTimeout(() => {
        //makeEnableDisablebtn(false)
         TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
      }, 2000);


    });
  });

 
  
  
  function makeEnableDisablebtn(isEnable) {

    if(isEnable){
       jQuery(checkoutButtonDrawerPage).prop('disabled', true);
      jQuery(checkoutButtonCartPage).prop('disabled', true);
      jQuery(checkoutButtonCartPage).text('\n                    \n                      Loading...\n                    \n                  '); 
      jQuery('.ac-drawer-checkout-text').text('\n                    \n                      Loading...\n                    \n                  ')
     

    }else{
   //    setTimeout(() => {
      jQuery(checkoutButtonCartPage).text('\n                    \n                      Checkout\n                    \n                  ')
      jQuery('.ac-drawer-checkout-text').text('\n                    \n                      Checkout\n                    \n                  ')
      jQuery(checkoutButtonCartPage).prop('disabled', false);
      jQuery(checkoutButtonDrawerPage).prop('disabled', false);
 //   }, 1000);
       }

  }

  
  
  
   

 // makeEnableDisablebtn(true)
  
  
    var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }

    TieredPricingCart(globalFieldsCartPage_AC.cartObj, true); CheckoutClickCart(); CheckoutClickAjax();
}

var CalculateMinQuantityCart = function (minQuantity,item,index) {

let Selectors = {
           currentQuantity:item?.quantity,
           variant_id:item?.variant_id,
            tabelQuantitySelectorPDpage: $(`.cart .cart-items .cart-item__qty .qty-input__input,cart-items[data-section="cart-drawer"] .cart-item__qty .qty-input__input`).eq(index),
            addToCartSelecter: $(''), // Replace with your actual selector
            errorMessage: $(`.cart .cart-items .cart-item__qty .cart-item__error,cart-items[data-section="cart-drawer"] .cart-item__qty .cart-item__error`).eq(index),
            errorMessageWrapper: $(`.cart .cart-items .cart-item__qty .cart-item__error,cart-items[data-section="cart-drawer"] .cart-item__qty .cart-item__error`).eq(index),
            quantityButton: $(`.cart .cart-items .cart-item__qty button[name="minus"],.cart .cart-items .cart-item__qty button[name="plus"],cart-items[data-section="cart-drawer"] .cart-item__qty button[name="minus"],cart-items[data-section="cart-drawer"] .cart-item__qty button[name="plus"]`).eq(index),
            qtyMinesSelector: $(`.cart .cart-items .cart-item__qty button[name="minus"],cart-items[data-section="cart-drawer"] .cart-item__qty button[name="minus"]`).eq(index),
             qtyPlusSelector: $(`.cart .cart-items .cart-item__qty button[name="plus"],cart-items[data-section="cart-drawer"] .cart-item__qty button[name="plus"]`).eq(index)
        };

    const $quantityInput = Selectors?.tabelQuantitySelectorPDpage,
          $addToCartButton = Selectors?.addToCartSelecter,
          $warningMessage = Selectors?.errorMessage,
          $warningMessageWrapper = Selectors?.errorMessageWrapper,
          $quantityButton = Selectors?.quantityButton,
          $quantityMinusButton = Selectors?.qtyMinesSelector,
           $quantityPlusButton = Selectors?.qtyPlusSelector,
          $variant_id = Selectors?.variant_id,
           $currentCartQuantity = Selectors?.currentQuantity
    
 let currentQuantity = parseInt($quantityInput.val(), 10)
  //if(currentQuantity){
//    currentQuantity = Number(currentQuantity)
    
 // }
        $warningMessage.text('');
        $warningMessageWrapper.attr('hidden', true);
  
    if (!$quantityInput?.length) return;

    const toggleButtonState = (isDisabled) => {
        $quantityMinusButton.prop('disabled', isDisabled).css({
            'cursor': isDisabled ? 'not-allowed' : '',
            'opacity': isDisabled ? '0.5' : '',
            'pointer-events': isDisabled ? 'none' : ''
        });
    };

 const validateQuantity = (userEnteredValue) => {
        let isInvalid = userEnteredValue >= Number(minQuantity) && userEnteredValue>= Number(minQuantity);
        currentQuantity = userEnteredValue >= currentQuantity ? userEnteredValue :Number(currentQuantity)
        toggleButtonState(currentQuantity <= Number(minQuantity));
        if (!isInvalid){ 
          showWarning(`Minimum order quantity is ${minQuantity}.`);
          return false;
         }
        return true;
    };


  const checkMinLength = (itemLength) =>{
for (let index = 0; index < itemLength; index++) {
     var userEnteredValue = Number(jQuery(`#quantity-${index+ 1}`).val());
      var minQuantity =   Number($(`#quantity-${index+ 1}`).attr('min'));
      let isInvalid = userEnteredValue >= Number(minQuantity) && userEnteredValue>= Number(minQuantity);
       if (!isInvalid){
       jQuery(`#line-item-error-${index+ 1}`).text(`Minimum order quantity is ${minQuantity}.`);
       jQuery(`#line-item-error-${index+ 1}`).attr('hidden', false);
        return false;   
    }
 }
  return true;  
};
  
    const setPageLoadMinQty = () => {
$quantityInput.attr('min', minQuantity);
        //  $quantityInput.attr('data-cart-quantity', minQuantity);
    };

    const showWarning = (message) => {

        $warningMessage.text(message);
        $warningMessageWrapper.removeAttr('hidden');
        toggleButtonState(true);
     // setMinQuantityCart($variant_id,minQuantity)
      //if(currentQuantity < minQuantity) $quantityPlusButton.click()

    };

    const hideWarning = () => {
    setTimeout(function(){
    $warningMessage.text('');
    $warningMessageWrapper.attr('hidden', true);
    }, 4000);
    };

    $quantityInput.on('change', (e) => {
       e.preventDefault();
        // if (e.key === 'ArrowDown' && currentQuantity <= minQuantity) 
    const userEnteredValue = e.target.value; 
      var value =  validateQuantity(Number(userEnteredValue));
      if(!value){
      hideWarning();
      return false;
      }
      return true;
    });

    //$quantityButton.on('click', validateQuantity);
    $quantityButton.on('click', (e) => {
      hideWarning()
        if (parseInt($quantityInput.val(), 10) < minQuantity) {
            e.preventDefault();
             
            showWarning(`Minimum order quantity is ${minQuantity}. Please select at least ${minQuantity} items.`);
      
        } else hideWarning();
    });

    setPageLoadMinQty();
  async function setMinQuantityCart(id, qty) {
     // makeEnableDisablebtn(true)
    return//uncomment this is want to run change.js
    try {
        const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: id.toString(),
                quantity: qty
            })
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

    } catch (error) {
        // console.error('Failed to update cart:', error);
    }
}
  
};


var globalFieldsCartPage_AC = new ACDiscountApp.CartPage.Global(); var cartObject = new ACDiscountApp.CartPage.Show_CalculateTier();